
export const GS20_GLOBAL_PARAM_SET_VARIABLE_NAME = "param_set";

export enum GS20_RatedVoltage {
    VAC120 = '120',
    VAC240 = '240',
    VAC480 = '480',
}

export interface Gs20ModbusSetting {
    address: Gs20ModbusAddress;
    value: number;
}



// Parameter to modbus address mapping for GS20 VFDs
export enum Gs20ModbusAddress {
    P0_0_Identity_Code = 0,
    P0_01_Rated_Current = 1,
    P0_02_Parameter_Reset = 2,
    P0_03_Start_up_Display = 3,
    P0_04_User_Display = 4,
    P0_05_H_page_scale = 5,
    P0_06_Firmware_Version = 6,
    P0_07_Password_Decoder = 7,
    P0_08_Password_Input = 8,
    P0_1_Control_Method = 10,
    P0_11_Velocity_Mode = 11,
    P0_16_Duty_Selection = 16,
    P0_17_Carry_Frequency = 17,
    P0_18_GS_Drive_Series = 18,
    P0_19_PLC_CMD_Mask = 19,
    P0_20_Source_of_FREQ = 20,
    P0_21_Source_of_OPER = 21,
    P0_22_Stop_Methods = 22,
    P0_23_Motor_Direction = 23,
    P0_24_Keypad_FREQ = 24,
    P0_25_User_COEFF_ATT = 25,
    P0_26_User_COEFF_MAX = 26,
    P0_27_User_COEFF_SET = 27,
    P0_29_LOC_REM_SEL = 29,
    P0_30_Hand_FREQ_Source = 30,
    P0_31_Hand_OPER_Source = 31,
    P0_32_KPD_STOP_ENABLE = 32,
    P0_35_AUX_FREQ_Source = 35,
    P0_36_AUX_FREQ_FUN_SEL = 36,
    P0_48_LPF_of_AMPS_Disp = 48,
    P0_49_LPF_of_Display = 49,
    P0_50_Date_Code = 50,
    P1_00_MAX_Output_FREQ = 256,
    P1_01_Motor1_Fbase = 257,
    P1_02_MAX_Out_VOLT_1 = 258,
    P1_03_MID_Out_FREQ_1_1 = 259,
    P1_04_MID_Out_VOLT_1_1 = 260,
    P1_05_MID_Out_FREQ_1_2 = 261,
    P1_06_MID_Out_VOLT_1_2 = 262,
    P1_07_MIN_Out_FREQ_1 = 263,
    P1_08_MIN_Out_VOLT_1 = 264,
    P1_09_Start_Frequency = 265,
    P1_10_Upper_Bound_FREQ = 266,
    P1_11_Lower_Bound_FREQ = 267,
    P1_12_1st_ACC_Time = 268,
    P1_13_1st_DEC_Time = 269,
    P1_14_2nd_ACC_Time = 270,
    P1_15_2nd_DEC_Time = 271,
    P1_16_3rd_ACC_Time = 272,
    P1_17_3rd_DEC_Time = 273,
    P1_18_4th_ACC_Time = 274,
    P1_19_4th_DEC_Time = 275,
    P1_20_JOG_ACC_Time = 276,
    P1_21_JOG_DEC_Time = 277,
    P1_22_JOG_Frequency = 278,
    P1_23_TRANS_ACC_DEC1_4 = 279,
    P1_24_S_Curve_Time_1 = 280,
    P1_25_S_Curve_Time_2 = 281,
    P1_26_S_Curve_Time_3 = 282,
    P1_27_S_Curve_Time_4 = 283,
    P1_28_Skip_FREQ__1Up = 284,
    P1_29_Skip_FREQ__1Low = 285,
    P1_30_Skip_FREQ__2Up = 286,
    P1_31_Skip_FREQ__2Low = 287,
    P1_32_Skip_FREQ__3Up = 288,
    P1_33_Skip_FREQ__3Low = 289,
    P1_34_Select_Zero_SPD = 290,
    P1_35_Motor2_Fbase = 291,
    P1_36_Max_Out_VOLT_2 = 292,
    P1_37_Mid_Out_FREQ_2_1 = 293,
    P1_38_Mid_Out_VOLT_2_1 = 294,
    P1_39_Mid_Out_FREQ_2_2 = 295,
    P1_40_Mid_Out_VOLT_2_2 = 296,
    P1_41_Min_Out_FREQ_2 = 297,
    P1_42_Min_Out_VOLT_2 = 298,
    P1_43_VF_Curve_Mode = 299,
    P1_44_Auto_ACC_DEC = 300,
    P1_45_ACC_DEC_TimeUnit = 301,
    P1_49_Decel_Method = 305,
    P1_52_MAX_Output_FREQ2 = 308,
    P1_53_MAX_Output_FREQ3 = 309,
    P1_54_Motor3_Fbase = 310,
    P1_55_Max_Out_VOLT_3 = 311,
    P1_56_Mid_Out_FREQ_3_1 = 312,
    P1_57_Mid_Out_VOLT_3_1 = 313,
    P1_58_Mid_Out_FREQ_3_2 = 314,
    P1_59_Mid_Out_VOLT_3_2 = 315,
    P1_60_Min_Out_FREQ_3 = 316,
    P1_61_Min_Out_VOLT_3 = 317,
    P1_62_MAX_Output_FREQ4 = 318,
    P1_63_Motor4_Fbase = 319,
    P1_64_Max_Out_VOLT_4 = 320,
    P1_65_Mid_Out_FREQ_4_1 = 321,
    P1_66_Mid_Out_VOLT_4_1 = 322,
    P1_67_Mid_Out_FREQ_4_2 = 323,
    P1_68_Mid_Out_VOLT_4_2 = 324,
    P1_69_Min_Out_FREQ_4 = 325,
    P1_70_Min_Out_VOLT_4 = 326,
    P2_00_2_3_wire_Control = 512,
    P2_01_MULTI_FUN_In_1 = 513,
    P2_02_MULTI_FUN_In_2 = 514,
    P2_03_MULTI_FUN_In_3 = 515,
    P2_04_MULTI_FUN_In_4 = 516,
    P2_05_MULTI_FUN_In_5 = 517,
    P2_06_MULTI_FUN_In_6 = 518,
    P2_07_MULTI_FUN_In_7 = 519,
    P2_09_Up_Down_Key_Mode = 521,
    P2_10_Up_Down_Key_SPD = 522,
    P2_11_MFI_Response = 523,
    P2_12_MULTI_Input_ACT = 524,
    P2_13_MULTI_FUN_RLY1 = 525,
    P2_16_MULTI_FUN_Out_1 = 528,
    P2_17_MULTI_FUN_Out_2 = 529,
    P2_18_MULTI_Output_ACT = 530,
    P2_19_Final_Counter = 531,
    P2_20_Middle_Counter = 532,
    P2_21_DO_Gain = 533,
    P2_22_Desire_FREQ1 = 534,
    P2_23_Desire_FREQ1_BND = 535,
    P2_24_Desire_FREQ2 = 536,
    P2_25_Desire_FREQ2_BND = 537,
    P2_34_Speed_Area_Set = 546,
    P2_35_Fault_Reset_OP = 547,
    P2_47_Desire_RPM = 559,
    P2_50_DIx_Status = 562,
    P2_51_Dox_Status = 563,
    P2_52_PLC_DI1_16_Mask = 564,
    P2_53_PLC_DO1_16_Mask = 565,
    P2_54_EXT_Speed_REC = 566,
    P2_58_Braking_Freq = 570,
    P2_78_GearRatioReducer = 590,
    P2_79_Index_Angle = 591,
    P2_80_Index_decel = 592,
    P2_81_Count_EF_Setup = 593,
    P2_82_Stop_Freq__Sel = 594,
    P2_83_Stop_Freq__Init = 595,
    P3_00_AI1_Selection = 768,
    P3_01_AI2_Selection = 769,
    P3_03_AI1_Input_Bias = 771,
    P3_04_AI2_Input_Bias = 772,
    P3_07_AI1_Bias_Mode = 775,
    P3_08_AI2_Bias_Mode = 776,
    P3_10_AI_Bias_REV_Mode = 778,
    P3_11_AI1_Input_Gain = 779,
    P3_12_AI2_Input_Gain = 780,
    P3_15_AI1_Input_LPF = 783,
    P3_16_AI2_Input_LPF = 784,
    P3_18_Addition_of_AI = 786,
    P3_19_Loss_of_AI2 = 787,
    P3_20_AO1_Setting = 788,
    P3_21_AO1_Gain = 789,
    P3_22_AO1_Output_Mode = 790,
    P3_27_AO1_Output_Bias = 795,
    P3_28_AI1v_AI1i_SEL = 796,
    P3_29_AI2i_AI2v_SEL = 797,
    P3_30_PLC_AO1_1_16mask = 798,
    P3_31_AO1_output = 799,
    P3_32_AO1_OUT_LEVEL = 800,
    P3_35_AO1_Output_LPF = 803,
    P3_39_VR_Selection = 807,
    P3_40_VR_Input_Bias = 808,
    P3_41_VR_Bias_Mode = 809,
    P3_42_VR_Input_Gain = 810,
    P3_43_VR_Input_LPF = 811,
    P3_44_DO_by_AI_level = 812,
    P3_45_DO_AI_Upper_Lev = 813,
    P3_46_DO_AI_Lower_Lev = 814,
    P3_47_AI1 = 815,
    P3_48_AI2 = 816,
    P3_50_AI_Curve_Select = 818,
    P3_57_AI2_Low_Point = 825,
    P3_58_AI2_Low = 826,
    P3_59_AI2_Mid_Point = 827,
    P3_60_AI2_Middle = 828,
    P3_61_AI2_High_Point = 829,
    P3_62_AI2_High = 830,
    P3_63_AI1_Low_Point = 831,
    P3_64_AI1_Low = 832,
    P3_65_AI1_Mid_Point = 833,
    P3_66_AI1_Mid = 834,
    P3_67_AI1_High_Point = 835,
    P3_68_AI1_High = 836,
    P3_69__AI1_High_Point = 837,
    P3_70__AI1_High = 838,
    P3_71__AI1_Mid_Point = 839,
    P3_72__AI1_Mid = 840,
    P3_73__AI1_Low_Point = 841,
    P3_74__AI1_Low = 842,
    P4_00_Multi_Speed_1 = 1024,
    P4_01_Multi_Speed_2 = 1025,
    P4_02_Multi_Speed_3 = 1026,
    P4_03_Multi_Speed_4 = 1027,
    P4_04_Multi_Speed_5 = 1028,
    P4_05_Multi_Speed_6 = 1029,
    P4_06_Multi_Speed_7 = 1030,
    P4_07_Multi_Speed_8 = 1031,
    P4_08_Multi_Speed_9 = 1032,
    P4_09_Multi_Speed_10 = 1033,
    P4_10_Multi_Speed_11 = 1034,
    P4_11_Multi_Speed_12 = 1035,
    P4_12_Multi_Speed_13 = 1036,
    P4_13_Multi_Speed_14 = 1037,
    P4_14_Multi_Speed_15 = 1038,
    P4_50_PLC_Buffer_0 = 1074,
    P4_51_PLC_Buffer_1 = 1075,
    P4_52_PLC_Buffer_2 = 1076,
    P4_53_PLC_Buffer_3 = 1077,
    P4_54_PLC_Buffer_4 = 1078,
    P4_55_PLC_Buffer_5 = 1079,
    P4_56_PLC_Buffer_6 = 1080,
    P4_57_PLC_Buffer_7 = 1081,
    P4_58_PLC_Buffer_8 = 1082,
    P4_59_PLC_Buffer_9 = 1083,
    P4_60_PLC_Buffer_10 = 1084,
    P4_61_PLC_Buffer_11 = 1085,
    P4_62_PLC_Buffer_12 = 1086,
    P4_63_PLC_Buffer_13 = 1087,
    P4_64_PLC_Buffer_14 = 1088,
    P4_65_PLC_Buffer_15 = 1089,
    P4_66_PLC_Buffer_16 = 1090,
    P4_67_PLC_Buffer_17 = 1091,
    P4_68_PLC_Buffer_18 = 1092,
    P4_69_PLC_Buffer_19 = 1093,
    P5_00_Auto_Tuning_SEL = 1280,
    P5_01_Motor1_Rated_A = 1281,
    P5_02_Motor1_Rated_P = 1282,
    P5_03_Motor1_Rated_S = 1283,
    P5_04_Motor1_Poles = 1284,
    P5_05_Motor1_No_Load = 1285,
    P5_06_Motor1_Rs = 1286,
    P5_07_Motor1_Rr = 1287,
    P5_08_Motor1_Lm = 1288,
    P5_09_Motor1_Lx = 1289,
    P5_13_Motor2_Rated_A = 1293,
    P5_14_Motor2_Rated_P = 1294,
    P5_15_Motor2_Rated_S = 1295,
    P5_16_Motor2_Poles = 1296,
    P5_17_Motor2_No_Load = 1297,
    P5_18_Motor2_Rs = 1298,
    P5_19_Motor2_Rr = 1299,
    P5_20_Motor2_Lm = 1300,
    P5_21_Motor2_Lx = 1301,
    P5_22_Motor_1_to_4 = 1302,
    P5_23_Y_D_Switch_Hz = 1303,
    P5_24_Y_D_Switch_SEL = 1304,
    P5_25_Y_D_Switch_Delay = 1305,
    P5_26_W_msec = 1306,
    P5_27_W_sec = 1307,
    P5_28_W_hrs = 1308,
    P5_29_kWh = 1309,
    P5_30_MWh = 1310,
    P5_31_Accumul_Run_Hour = 1311,
    P5_32_Accumul_Run_day = 1312,
    P5_33_IM_PM_Selection = 1313,
    P5_34_PM_Rated_Current = 1314,
    P5_35_PM_Rated_Power = 1315,
    P5_36_PM_Rated_RPM = 1316,
    P5_37_PM_Pole_number = 1317,
    P5_39_PM_Rs = 1319,
    P5_40_PM_Ld = 1320,
    P5_41_PM_Lq = 1321,
    P5_43_PM_Ke_Cofficient = 1323,
    P5_64_Motor3_Rated_A = 1344,
    P5_65_Motor3_Rated_P = 1345,
    P5_66_Motor3_Rated_S = 1346,
    P5_67_Motor3_Poles = 1347,
    P5_68_Motor3_No_Load = 1348,
    P5_69_Motor3_Rs = 1349,
    P5_70_Motor4_Rated_A = 1350,
    P5_71_Motor4_Rated_P = 1351,
    P5_72_Motor4_Rated_S = 1352,
    P5_73_Motor4_Poles = 1353,
    P5_74_Motor4_No_Load = 1354,
    P5_75_Motor4_Rs = 1355,
    P6_00_Low_Voltage = 1536,
    P6_01_OV_Stall_Level = 1537,
    P6_02_STALL_V_MODE = 1538,
    P6_03_OCA_Level = 1539,
    P6_04_OCN_Level = 1540,
    P6_05_Stall_ACCDEC_SEL = 1541,
    P6_06_Over_TQC1_Method = 1542,
    P6_07_Over_TQC1_Level = 1543,
    P6_08_Over_TQC1_Time = 1544,
    P6_09_Over_TQC2_Method = 1545,
    P6_10_Over_TQC2_Level = 1546,
    P6_11_Over_TQC2_Time = 1547,
    P6_12_Current_Limit = 1548,
    P6_13_Thermal_RLY1_SEL = 1549,
    P6_14_Thermal_RLY1_T = 1550,
    P6_15_OH_Warn_Level = 1551,
    P6_16_Stall_Level_LIMT = 1552,
    P6_17_1st_Fault_Record = 1553,
    P6_18_2nd_Fault_Record = 1554,
    P6_19_3rd_Fault_Record = 1555,
    P6_20_4th_Fault_Record = 1556,
    P6_21_5th_Fault_Record = 1557,
    P6_22_6th_Fault_Record = 1558,
    P6_23_Fault_Option_1 = 1559,
    P6_24_Fault_Option_2 = 1560,
    P6_25_Fault_Option_3 = 1561,
    P6_26_Fault_Option_4 = 1562,
    P6_27_Thermal_RLY2_SEL = 1563,
    P6_28_Thermal_RLY2_T = 1564,
    P6_29_PTC_Treatments = 1565,
    P6_30_PTC_Level = 1566,
    P6_31_CMD_FREQ__REC = 1567,
    P6_32_Out_FREQ__REC = 1568,
    P6_33_Out_Voltage_REC = 1569,
    P6_34_DCBus_Value_REC = 1570,
    P6_35_Isum_Value_REC = 1571,
    P6_36_IGBT_Temp__REC = 1572,
    P6_38_RPM_of_Motor_REC = 1574,
    P6_39_Torque_REC = 1575,
    P6_40_DI_Status_REC = 1576,
    P6_41_DO_Status_REC = 1577,
    P6_42_INV_Status_REC = 1578,
    P6_43_IGBT_Temperature = 1579,
    P6_44_STO_Latch_Func = 1580,
    P6_45_Output_Phase_Los = 1581,
    P6_46_OPL_Detection_T = 1582,
    P6_47_OPL_Curren_Band = 1583,
    P6_48_DCI_Time_for_OPL = 1584,
    P6_49_LvX_Auto_Reset = 1585,
    P6_53_PHL_Treatment = 1589,
    P6_55_Derating_Method = 1591,
    P6_56_PT_DET_LEVEL1 = 1592,
    P6_57_PT_DET_LEVEL2 = 1593,
    P6_58_PT_DROP_FREQ = 1594,
    P6_59_PT_Treat_Delay = 1595,
    P6_60_GFF_Detect_Level = 1596,
    P6_61_GFF_LPF_Gain = 1597,
    P6_63_Error_REC_1_Day = 1599,
    P6_64_Error_REC_1_Min = 1600,
    P6_65_Error_REC_2_Day = 1601,
    P6_66_Error_REC_2_Min = 1602,
    P6_67_Error_REC_3_Day = 1603,
    P6_68_Error_REC_3_Min = 1604,
    P6_69_Error_REC_4_Day = 1605,
    P6_70_Error_REC_4_Min = 1606,
    P6_71_Under_AMP_Level = 1607,
    P6_72_Under_AMP_DET = 1608,
    P6_73_Under_AMP_TRET = 1609,
    P6_80_Fire_Mode = 1616,
    P6_81_Fire_Frequency = 1617,
    P6_88_Fire_Count = 1624,
    P6_90_Error_REC_5_Day = 1626,
    P6_91_Error_REC_5_Min = 1627,
    P6_92_Error_REC_6_Day = 1628,
    P6_93_Error_REC_6_Min = 1629,
    P7_00_SW_Braking_Level = 1792,
    P7_01_DC_Inject_Level = 1793,
    P7_02_DC_Inject_Start = 1794,
    P7_03_DC_Inject_Stop = 1795,
    P7_04_DC_Inject_StartF = 1796,
    P7_05_Voltage_INC_Gain = 1797,
    P7_06_Momentary_Power = 1798,
    P7_07_Power_Loss_Time = 1799,
    P7_08_Base_Block_Time = 1800,
    P7_09_SPD_Search_Curr = 1801,
    P7_10_Fault_Re_RUN_Way = 1802,
    P7_11_Auto_Restart = 1803,
    P7_12_Restart_Method = 1804,
    P7_13_dEb_Decel_SEL = 1805,
    P7_15_Dwell_ACC_Time = 1807,
    P7_16_Dwell_ACC_FREQ = 1808,
    P7_17_Dwell_DEC_Time = 1809,
    P7_18_Dwell_DEC_FREQ = 1810,
    P7_19_Cooling_Fan_Way = 1811,
    P7_20_EF_Stop_Select = 1812,
    P7_21_PowerSave_Enable = 1813,
    P7_22_PowerSave_Gain = 1814,
    P7_23_Auto_Voltage_REG = 1815,
    P7_24_TQR_COMP_Filter = 1816,
    P7_25_Slip_COMP_Filter = 1817,
    P7_26_TQR_COMP_Gain = 1818,
    P7_27_Slip_COMP_Gain = 1819,
    P7_29_Slip_Deviation_L = 1821,
    P7_30_Slip_Deviation_T = 1822,
    P7_31_Over_Slip_Way = 1823,
    P7_32_MTR_Oscill_CMP = 1824,
    P7_33_Reset_RestartCNT = 1825,
    P7_38_SVC_VFFD_Gain = 1830,
    P7_46_OOB_Sample_Time = 1838,
    P7_47_OOB_Sample_Cnt = 1839,
    P7_48_OOB_Sample_Angle = 1840,
    P7_62_dEb_DEC_Ikp = 1854,
    P7_63_dEb_DEC_Iki = 1855,
    P7_71_M2_TQR_COMP_Gain = 1863,
    P7_72_M2Slip_COMP_Gain = 1864,
    P7_73_M3_TQR_COMP_Gain = 1865,
    P7_74_M3Slip_COMP_Gain = 1866,
    P7_75_M4_TQR_COMP_Gain = 1867,
    P7_76_M4Slip_COMP_Gain = 1868,
    P8_00_PID_FBK_SEL = 2048,
    P8_01_P_Gain_of_PID = 2049,
    P8_02_I_Gain_of_PID = 2050,
    P8_03_D_Gain_of_PID = 2051,
    P8_04_Up_Limit_for_I = 2052,
    P8_05_PID_Out_Limit = 2053,
    P8_06_PID_Fbk_Value = 2054,
    P8_07_PID_Out_Filter = 2055,
    P8_08_FBK_Detect_Time = 2056,
    P8_09_PID_FBK_Loss = 2057,
    P8_10_Sleep_Point = 2058,
    P8_11_Wake_Point = 2059,
    P8_12_Sleep_Time = 2060,
    P8_13_PID_DEV__Level = 2061,
    P8_14_PID_DEV__Time = 2062,
    P8_15_PID_FBK_Filter = 2063,
    P8_16_PID_Offset_Way = 2064,
    P8_17_PID_Offset = 2065,
    P8_18_Source_of_Sleep = 2066,
    P8_19_I_Limit_for_Wake = 2067,
    P8_20_PID_Mode = 2068,
    P8_21_PID_Reverse = 2069,
    P8_22_Wake_Delay_Time = 2070,
    P8_23_PID_CTRL_BIT = 2071,
    P8_26_PID_Neg_OutLmit = 2074,
    P8_27_PID_Cmd_ACC_DEC = 2075,
    P8_29_PID_Base_SEL = 2077,
    P8_31_P_Gain2_of_PID = 2079,
    P8_32_I_Gain2_of_PID = 2080,
    P8_33_D_Gain2_of_PID = 2081,
    P8_65_PID_REF_SEL = 2113,
    P8_66_PID_REF = 2114,
    P8_67_AUX_PID_REV_MAX = 2115,
    P8_68_PID_Hold_By_Err = 2116,
    P8_69_I_GAIN_Disable = 2117,
    P8_70_PID_Enable_Level = 2118,
    P8_71_Smart_Start_Freq = 2119,
    P8_72_Smsrt_Start_Acc = 2120,
    P8_75_PID_Gain2_Sel = 2123,
    P8_76_PID_Gain2_Err1 = 2124,
    P8_77_PID_Gain2_Err2 = 2125,
    P8_78_Rev_After_Start = 2126,
    P9_00_VFD_Comm_Address = 2304,
    P9_01_MODBUS_BaudRate = 2305,
    P9_02_MODBUS_Fault_Way = 2306,
    P9_03_MODBUS_Time_Out = 2307,
    P9_04_MODBUS_Protocol = 2308,
    P9_09_Response_Delay_T = 2313,
    P9_10_Comm_Main_FREQ = 2314,
    P9_11_Block_TRANS__1 = 2315,
    P9_12_Block_TRANS__2 = 2316,
    P9_13_Block_TRANS__3 = 2317,
    P9_14_Block_TRANS__4 = 2318,
    P9_15_Block_TRANS__5 = 2319,
    P9_16_Block_TRANS__6 = 2320,
    P9_17_Block_TRANS__7 = 2321,
    P9_18_Block_TRANS__8 = 2322,
    P9_19_Block_TRANS__9 = 2323,
    P9_20_Block_TRANS__10 = 2324,
    P9_21_Block_TRANS__11 = 2325,
    P9_22_Block_TRANS__12 = 2326,
    P9_23_Block_TRANS__13 = 2327,
    P9_24_Block_TRANS__14 = 2328,
    P9_25_Block_TRANS__15 = 2329,
    P9_26_Block_TRANS__16 = 2330,
    P9_30_Com_Decode = 2334,
    P9_33_PLC_Cmd_Force_0 = 2337,
    P9_35_PLC_Address = 2339,
    P9_60_C_Card_Type = 2364,
    P9_61_C_Card_Version = 2365,
    P9_62_C_Card_P_Code = 2366,
    P9_63_C_Card_Err_Code = 2367,
    P9_74_Set_Protocol = 2378,
    P9_75_C_Card_IP_CONF = 2379,
    P9_76_C_Card_IP_ADS1 = 2380,
    P9_77_C_Card_IP_ADS2 = 2381,
    P9_78_C_Card_IP_ADS3 = 2382,
    P9_79_C_Card_IP_ADS4 = 2383,
    P9_80_C_Card_Mask_ADS1 = 2384,
    P9_81_C_Card_Mask_ADS2 = 2385,
    P9_82_C_Card_Mask_ADS3 = 2386,
    P9_83_C_Card_Mask_ADS4 = 2387,
    P9_84_C_Card_GWay_ADS1 = 2388,
    P9_85_C_Card_GWay_ADS2 = 2389,
    P9_86_C_Card_GWay_ADS3 = 2390,
    P9_87_C_Card_GWay_ADS4 = 2391,
    P9_88_C_Card_Pssword_L = 2392,
    P9_89_C_Card_Pssword_H = 2393,
    P9_90_C_Card_RECOV_Rst = 2394,
    P9_91_C_Card_Ext_Set = 2395,
    P9_92_C_Card_Status = 2396,
    P9_93_TimeO_Sel_C_Card = 2397,
    P9_94_TimeO_Det_C_Card = 2398,
    P9_95_TimeO_Dur_C_Card = 2399,
    P10_00_Encoder_Type = 2560,
    P10_01_Encoder_Pulse = 2561,
    P10_02_Encoder_Signal = 2562,
    P10_04_PG_MECH_Gear_A1 = 2564,
    P10_05_PG_MECH_Gear_B1 = 2565,
    P10_06_PG_MECH_Gear_A2 = 2566,
    P10_07_PG_MECH_Gear_B2 = 2567,
    P10_10_OverSPD_Level = 2570,
    P10_11_OverSPD_DET_Time = 2571,
    P10_12_OverSPD_Treat = 2572,
    P10_13_Deviation_Level = 2573,
    P10_14_Deviation_DET = 2574,
    P10_15_Deviation_Treat = 2575,
    P10_16_REF_Pulse_Signal = 2576,
    P10_17_Electrical_GearA = 2577,
    P10_18_Electrical_GearB = 2578,
    P10_21_REF_Pulse_Filter = 2581,
    P10_24_SYS_CTRL_Bit = 2584,
    P10_25_BW_of_FLUX_BEMF = 2585,
    P10_26_FOC_Fmin = 2586,
    P10_27_LPF_of_FLX_OBSER = 2587,
    P10_28_FLUX_Riseing_T = 2588,
    P10_29_MAX_Slip_Freq = 2589,
    P10_31_I_F_Id_Level = 2591,
    P10_32_Hi_SPD_OBS_BW = 2592,
    P10_34_EST_FREQ_LPF = 2594,
    P10_35_Kp_of_AMR = 2595,
    P10_36_Ki_of_AMR = 2596,
    P10_39_VFIRMS_to_VFFLUX = 2599,
    P10_42_Rot_Pos_Det_PLS = 2602,
    P10_49_ZeroVoltage_Time = 2609,
    P10_51_INJ_Frequency = 2611,
    P10_52_INJ_Magnitude = 2612,
    P10_53_Mag_Angle_DET = 2613,
    P11_00_System_Control = 2816,
    P11_01_System_Jm = 2817,
    P11_02_ASR1_2_Switch_F = 2818,
    P11_03_ASR1_BandWidth = 2819,
    P11_04_ASR2_BandWidth = 2820,
    P11_05_ASR_ZS_Bwidth = 2821,
    P11_06_ASR1_Kp_Low_SPD = 2822,
    P11_07_ASR1_Ki_Low_SPD = 2823,
    P11_08_ASR2_Kp_HighSPD = 2824,
    P11_09_ASR2_Ki_HighSPD = 2825,
    P11_10_ASR_Kp_Zero_SPD = 2826,
    P11_11_ASR_Ki_Zero_SPD = 2827,
    P11_12_ASR_FFD_Gain = 2828,
    P11_13_SPD_Loop_Kr_Gain = 2829,
    P11_14_ASR_Output_LPF = 2830,
    P11_15_Notch_Depth = 2831,
    P11_16_Notch_Freq = 2832,
    P11_17_FWD_Motor_Tq_LIM = 2833,
    P11_18_FWD_Reg__Tq_LIM = 2834,
    P11_19_REV_Motor_Tq_LIM = 2835,
    P11_20_REV_Reg__Tq_LIM = 2836,
    P11_21_Motor1_Id_Curve = 2837,
    P11_22_Motor2_Id_Curve = 2838,
    P11_23_FluxWeak_ACC_DEC = 2839,
    P11_27_TQR_MAX_Level = 2843,
    P11_28_TQR_Offset_SEL = 2844,
    P11_29_TQR_Offset_Level = 2845,
    P11_30_TQR_Offset_High = 2846,
    P11_31_TQR_Offset_MID = 2847,
    P11_32_TQR_Offset_Low = 2848,
    P11_33_Source_of_TQR = 2849,
    P11_34_Torque_REF = 2850,
    P11_35_TQR_Com_Filter = 2851,
    P11_36_Speed_Limit_SEL = 2852,
    P11_37_TQR__SPD_Limit = 2853,
    P11_38_TQR__SPD_Limit = 2854,
    P11_41_PWM_Mode = 2857,
    P11_42_System_Flag = 2858,
    P13_00_MacroSelection = 3328,
    P14_50_Out_FREQ_REC_2 = 3634,
    P14_51_DCBus_Value_REC2 = 3635,
    P14_52_Isum_Value_REC_2 = 3636,
    P14_53_IGBT_Temp__REC_2 = 3637,
    P14_54_Out_FREQ_REC_3 = 3638,
    P14_55_DCBus_Value_REC3 = 3639,
    P14_56_Isum_Value_REC_3 = 3640,
    P14_57_IGBT_Temp__REC_3 = 3641,
    P14_58_Out_FREQ_REC_4 = 3642,
    P14_59_DCBus_Value_REC4 = 3643,
    P14_60_Isum_Value_REC_4 = 3644,
    P14_61_IGBT_Temp__REC_4 = 3645,
    P14_62_Out_FREQ_REC_5 = 3646,
    P14_63_DCBus_Value_REC5 = 3647,
    P14_64_Isum_Value_REC_5 = 3648,
    P14_65_IGBT_Temp__REC_5 = 3649,
    P14_66_Out_FREQ_REC_6 = 3650,
    P14_67_DCBus_Value_REC6 = 3651,
    P14_68_Isum_Value_REC_6 = 3652,
    P14_69_IGBT_Temp__REC_6 = 3653,
    P14_7_7th_Fault_Record = 3654,
    P14_71_8th_Fault_Record = 3655,
    P14_72_9th_Fault_Record = 3656,
    P14_73_10th_FaultRecord = 3657,
    P14_74_Over_TQC3_Method = 3658,
    P14_75_Over_TQC3_Level = 3659,
    P14_76_Over_TQC3_Time = 3660,
    P14_77_Over_TQC4_Method = 3661,
    P14_78_Over_TQC4_Level = 3662,
    P14_79_Over_TQC4_Time = 3663,
    P14_80_Thermal_RLY3_SEL = 3664,
    P14_81_Thermal_RLY3_T = 3665,
    P14_82_Thermal_RLY4_SEL = 3666,
    P14_83_Thermal_RLY4_T = 3667,
}